import type { AuthTokenResponse } from "@/api/register";
import { axiosInstance } from "@/axios/interceptors";

/**
 * POST /v2/auth/refresh_access_token
 * Uses the current Bearer token (and default request params from axios interceptors).
 */
export async function refreshAccessToken(): Promise<AuthTokenResponse> {
	const response = await axiosInstance.post<AuthTokenResponse>(
		"/auth/refresh_access_token",
		{},
	);
	return response.data;
}
